import Vue from 'vue'
import Router from 'vue-router'
import HomeScreen from './components/home/HomeScreen.vue';
import EndScreen from './components/end/EndScreen.vue';
import QuizScreen from './components/quiz/QuizScreen.vue';
import PrizesScreen from './components/prize/PrizesScreen.vue';

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'homeScreen',
            component: HomeScreen
        },
        {
            path: '/quiz',
            name: 'quizScreen',
            component: QuizScreen
        },
        {
            path: '/end-screen',
            name: 'endScreen',
            component: EndScreen
        },
        {
            path: '/prizes',
            name: 'prizesScreen',
            component: PrizesScreen
        }
    ]
})
